import type { Dict } from "../types";

export const services: Dict = {
  en: {

    // ServiceSelector
    "Services.title": "Select a Service",
    "Services.subtitle": "Choose from our services",
    "Services.subtitleMulti": "Select one or more services",
    "Services.duration": "min",
    "Services.noServices": "No services available",
    "Services.callToBook": "Call to book",
    "Services.onlineBooking": "Online booking",
    "Services.hiddenOnline": "Hidden online",
    "Services.selectService": "Select service",
    "Services.searchService": "Search for a service...",
    "Services.pickerOtherServices": "Other services",
    "Services.pickerServices": "Services",
    "Services.noServiceFound": "No service found",
    "Services.variableDuration": "Variable duration",
    "Services.startingFromDuration": "From {duration} min",
    "Services.variablePrice": "Variable price",
    "Services.startingFromPrice": "From {price}",
    "Services.seeMore": "See more",
    "Services.seeLess": "See less",
    "Services.durationLabel": "Service duration (minutes) *",
    "Services.durationPlaceholder": "e.g., 60",
    "Services.durationRequired": "Please enter the service duration",
    "Services.enterDurationFirst": "Enter a duration first",
    "Services.variableDurationNote":
      "This service has a variable duration. Please indicate the expected duration in minutes.",
    "Services.variableDurationAutoDisable": "Online booking is automatically disabled for variable duration services.",
    "Services.selectedCount": "{count} services selected",
    "Services.selectedCountSingular": "1 service selected",
    "Services.priceFrom": "Starting from",
    "Services.employeePricing.title": "Price per employee",
    "Services.employeePricing.description": "Set different prices depending on the employee",
    "Services.employeePricing.hint": "The base price will be used for employees without a custom price",
    "Services.employeePricing.toggle": "Same price for all",
    "Services.employeePricing.basePrice": "Base price",
    "Services.employeePricing.customPrice": "Custom price",

    // ServicesView
    "Services.headerSubtitle": "Catalog, packages and prices for your salon.",
    "Services.tabCatalogue": "Catalog",
    "Services.tileServices": "Services",
    "Services.tileCategories": "Categories",
    "Services.tileAvgPrice": "Avg. price",
    "Services.catalogueTitle": "Catalog",
    "Services.catalogueDesc": "Services grouped by section.",
    "Services.loadFailedTitle": "Your services could not be loaded",
    "Services.loadFailedEmpty": "This is not an empty catalog. The read failed, so nothing can be shown right now. Try again, and sign in again if it keeps failing.",
    "Services.loadFailedStale": "The catalog could not be reloaded. What you see may no longer match what is saved.",
    "Services.reloadSucceeded": "The catalog is loaded again and up to date.",
    "Services.reloadFailedAgain": "The catalog still could not be loaded. What you see may no longer match what is saved. Try again, and sign in again if it keeps failing.",
    "Services.sectionWriteBlockedStale": "The service list on screen could not be reloaded, so it may no longer match what is saved. Reload the catalog before you rename or delete a section.",
    "Services.uncategorized": "Uncategorized",
    "Services.catalogueHint": "catalog {details}",
    "Services.catalogueSearchPlaceholder": "Search for a service",
    "Services.catalogueColService": "Service",
    "Services.catalogueColDuration": "Duration",
    "Services.catalogueColPrice": "Price",
    "Services.catalogueColOnline": "Online",
    "Services.catalogueColShortName": "Short name",
    "Services.catalogueColDescription": "Description",
    "Services.catalogueFilterOnline": "Filter by online status",
    "Services.catalogueNoMatch": "No service matches your search.",
    "Services.catalogueClearSearch": "Clear search",
    "Services.catalogueShown": "{shown} of {total} services shown",
    "Services.catalogueShownOne": "{shown} of {total} services shown",
    "Services.catalogueExpand": "Expand {group}",
    "Services.catalogueCollapse": "Collapse {group}",
    // Invites des champs de prix et de duree par employe. Elles doivent se LIRE comme
    // des exemples : « 0.00 » et « 30 » passaient pour des valeurs deja saisies
    // (audit 2026-08-26, probleme 85).
    "Services.priceExample": "e.g. 45",
    "Services.durationExample": "e.g. 30",
    "Services.forfaitsDesc": "Bundle several services into a package.",
    "SalonManagement.add": "Add",
    "Forfait.empty": "No packages yet.",

    // Salon Info - Tax numbers
    "SalonManagement.tpsNumber": "GST/TPS Number",
    "SalonManagement.tvqNumber": "QST/TVQ Number",

    // SalonManagement
    "SalonManagement.salonInfo": "Salon Information",
    "SalonManagement.salonName": "Salon Name",
    "SalonManagement.required": "Required",
    "SalonManagement.address": "Address",
    "SalonManagement.phone": "Phone",
    "SalonManagement.email": "Email",
    "SalonManagement.invalidEmail": "Please enter a valid email address",
    "SalonManagement.website": "Website",
    "SalonManagement.enterWebsite": "Enter your website URL",
    "SalonManagement.invalidWebsite": "Please enter a valid website URL",
    "SalonManagement.googleReviewsUrl": "Google review link",
    "SalonManagement.enterGoogleReviewsUrl": "https://g.page/r/.../review",
    "SalonManagement.invalidGoogleReviewsUrl": "Please enter a valid Google review URL",
    "SalonManagement.reviewRequestsEnabled": "Clients receive a review request after their appointment.",
    "SalonManagement.reviewRequestsDisabled": "No review request is sent.",
    "SalonManagement.descriptionDiscounts": "Description / Special Discounts",
    "SalonManagement.saveSalonInfo": "Save Salon Info",
    "SalonManagement.saveChanges": "Save Changes",
    "SalonManagement.hairdressers": "Employees",
    "SalonManagement.addHairdresser": "Add Employee",
    "SalonManagement.noHairdressersYet": "No employees yet. Add your first employee to get started!",
    "SalonManagement.edit": "Edit",
    "SalonManagement.delete": "Delete",
    "SalonManagement.addNewHairdresser": "Add New Employee",
    "SalonManagement.editHairdresser": "Edit Employee",
    "SalonManagement.hairdresserName": "Person Name",
    "SalonManagement.level": "Level",
    "SalonManagement.selectLevel": "Select level",
    "SalonManagement.noLevel": "None",
    "SalonManagement.newTalent": "New-Talent",
    "SalonManagement.beginner": "Beginner",
    "SalonManagement.intermediate": "Intermediate",
    "SalonManagement.advanced": "Advanced",
    "SalonManagement.expert": "Expert",
    "SalonManagement.profilePicture": "Profile Picture",
    "SalonManagement.uploadImage": "Upload Image",
    "SalonManagement.cancel": "Cancel",
    "SalonManagement.save": "Save",
    "SalonManagement.calendarColor": "Calendar color",
    "SalonManagement.resetColor": "Reset color",
    "SalonManagement.colorPreview": "Preview",
    "SalonManagement.specializations": "Specializations",
    "SalonManagement.specializationsDescription":
      "Select the sections, subsections, and services this employee can perform. If none selected, they cannot handle any service.",
    "SalonManagement.noSections": "No sections available. Create sections first.",
    "SalonManagement.employeeSpecializations": "Employee Specializations",
    "SalonManagement.selectEmployee": "Select an employee",
    "SalonManagement.specializationHelp": "Select the sections and subsections this employee can perform. Use the ✎ icon to fine-tune by service.",
    "SalonManagement.specializationSaved": "Specializations saved",
    "SalonManagement.servicesCount": "{count}/{total} services",
    "SalonManagement.servicesCountCompact": "{count}/{total}",
    "SalonManagement.servicesForSubsection": "Services: {name}",
    "SalonManagement.noSubsectionLabel": "Without subsection",
    "SalonManagement.servicesSelected": "{count} of {total} services selected",
    "SalonManagement.selectAllServices": "Select all",
    "SalonManagement.deselectAllServices": "Deselect all",
    "SalonManagement.noServicesInSubsection": "No services in this subsection.",
    "SalonManagement.serviceColor": "Service Color",
    "SalonManagement.serviceColorHint": "Optional. Used when \"By service\" color mode is enabled.",
    "ServiceSegments.requireDurations": "Set a duration for every eligible employee before splitting into segments.",

    "SalonManagement.services": "Services",
    "SalonManagement.addService": "Add Service",
    "SalonManagement.section": "Section",
    "SalonManagement.sections": "Sections",
    "SalonManagement.subsections": "Subsections",
    "SalonManagement.reorder": "Reorder",
    "SalonManagement.reorderDone": "Done",
    "Organize.button": "Organize",
    "Organize.online": "Online (customers)",
    "Organize.internal": "Internal (staff)",
    "Organize.emptyNoServices": "Nothing to organize yet. Add your services in the Catalog tab and they will appear here, under their section.",
    "Organize.emptyServicesUnknown": "Your services could not be read, so there is nothing to organize right now. This is not an empty catalog.",
    "Organize.emptyNoSection": "None of your services belongs to one of your sections, so there is no order to set here. Give your services a section in the Catalog tab and they will appear here.",
    "Organize.reorderFailed": "The new order could not be fully saved. The list is being reloaded to show the order that is really stored.",
    "SalonManagement.noServices": "No services yet. Add your first service to get started!",
    "SalonManagement.duration": "Duration",
    "SalonManagement.min": "min",
    "SalonManagement.variable": "Variable",
    "SalonManagement.priceStartingFrom": "From {price}",
    "SalonManagement.durationStartingFrom": "From {duration} min",
    "SalonManagement.addNewService": "Add New Service",
    "SalonManagement.editService": "Edit Service",
    "SalonManagement.selectSection": "Select Section",
    "SalonManagement.uncategorized": "Uncategorized",
    "SalonManagement.createNewSection": "Create New Section",
    "SalonManagement.serviceName": "Service Name",
    "SalonManagement.price": "Price",
    "SalonManagement.description": "Description",
    "SalonManagement.salonInfoUpdated": "Salon information updated successfully",
    "SalonManagement.failedToUpdateSalon": "Failed to update salon information",
    "SalonManagement.success": "Success",
    "SalonManagement.hairdresserUpdated": "Employee updated",
    "SalonManagement.hairdresserAdded": "Employee added",
    "SalonManagement.hairdresserDeleted": "Employee deleted successfully",
    "SalonManagement.serviceUpdated": "Service updated",
    "SalonManagement.serviceAdded": "Service added",
    "SalonManagement.serviceDeleted": "Service deleted. Related appointments have been updated.",
    "SalonManagement.sectionDeletedNone": "Section deleted",
    "SalonManagement.sectionDeletedService": "Section deleted, 1 service is now without a section",
    "SalonManagement.sectionDeletedServices": "Section deleted, {count} services are now without a section",
    "SalonManagement.sectionCreated": "Section created successfully",
    "SalonManagement.sectionRenamed": "Section renamed successfully",
    "SalonManagement.sectionRenamePartial": "The section was renamed, but not all of its services followed. The list is being reloaded to show the real state.",
    "SalonManagement.sectionDeletePartialService": "The section was not deleted, but {count} service has already lost it. The list is being reloaded to show the real state.",
    "SalonManagement.sectionDeletePartialServices": "The section was not deleted, but {count} services have already lost it. The list is being reloaded to show the real state.",
    "SalonManagement.openingHoursUpdated": "Opening hours updated",
    "SalonManagement.salonInfoUpdatedShort": "Salon information updated",
    "SalonManagement.invalidImageFile": "Please select a valid image file",
    "SalonManagement.fileTooLarge": "File size must be less than 5MB",
    "SalonManagement.hairdresserNameRequired": "Person name is required",
    "SalonManagement.noSalonFound": "No salon found",
    "SalonManagement.fillRequiredFields": "Please fill in all required fields",
    "SalonManagement.enterSectionName": "Please enter a section name",
    "SalonManagement.enterSalonName": "Enter salon name",
    "SalonManagement.enterAddress": "Enter address",
    "SalonManagement.enterPhone": "Enter phone number",
    "SalonManagement.enterEmail": "Enter email",
    "SalonManagement.enterDescription": "Enter description",
    "SalonManagement.salonNameRequired": "Salon name is required",
    "SalonManagement.serviceDeletedSimple": "Service deleted successfully",
    "SalonManagement.confirmDeletion": "Confirm Deletion",
    "SalonManagement.deleteServiceConfirm": "Are you sure you want to delete this service?",
    "SalonManagement.deleteServiceWarning": "Warning:",
    "SalonManagement.deleteServiceWarningText":
      "If appointments are using this service, they will be updated to have no service assigned.",
    "SalonManagement.deleteServiceConfirmNamed": "Are you sure you want to delete the service \"{name}\"?",
    "SalonManagement.deleteServiceImpactAppointment": "{count} appointment will lose its service.",
    "SalonManagement.deleteServiceImpactAppointments": "{count} appointments will lose their service.",
    "SalonManagement.deleteServiceImpactNone": "No appointment uses this service.",
    "SalonManagement.deleteServiceImpactUnavailable": "Unable to establish how many appointments would be affected.",
    "SalonManagement.deleteCountInProgress":
      "A deletion is already being measured. Wait for that count to finish before opening another one.",
    "SalonManagement.deleteHairdresserConfirm":
      "Are you sure you want to delete this employee? This action cannot be undone.",
    "SalonManagement.deleteButton": "Delete",
    "SalonManagement.client": "Client",
    "SalonManagement.selectClient": "Select client...",
    "SalonManagement.searchClient": "Search client by name, email or phone...",
    "SalonManagement.noClientFound": "No client found.",
    "ServiceSegments.title": "Split Service into Work/Pause Segments",
    "ServiceSegments.description": "Define work and pause periods within this service",
    "ServiceSegments.enabled": "Enabled",
    "ServiceSegments.disabled": "Disabled",
    "ServiceSegments.work": "Work",
    "ServiceSegments.pause": "Pause",
    "ServiceSegments.min": "min",
    "ServiceSegments.addSegment": "Add Segment",
    "ServiceSegments.total": "Total:",
    "ServiceSegments.mustEqual": "Must equal",
    "ServiceSegments.defaultLabel": "Default (all employees)",
    "ServiceSegments.perEmployee": "Per employee",
    "ServiceSegments.customize": "Customize",
    "ServiceSegments.customized": "Customized",
    "ServiceSegments.reset": "Reset to default",
    "ServiceSegments.mustEqualEmployee": "must equal {name}'s duration",
    "ServiceSegments.defaultBadge": "Default",
    "ServiceSegments.firstMustBeWork": "First segment must be work",
    "ServiceSegments.lastMustBeWork": "Last segment must be work",
    "Forfait.title": "Packages",
    "Forfait.addForfait": "Forfait",
    "Forfait.new": "New package",
    "Forfait.edit": "Edit package",
    "Forfait.addDescription": "Add the details of your new package",
    "Forfait.editDescription": "Update the details of your package",
    "Forfait.name": "Package name",
    "Forfait.nameLabel": "Package name",
    "Forfait.descriptionLabel": "Description",
    "Forfait.description": "Description (optional)",
    "Forfait.active": "Active",
    "Forfait.activeHint": "Visible on the booking page",
    "Forfait.addService": "Add a service",
    "Forfait.addPause": "Add a pause",
    "Forfait.employee": "Employee",
    "Forfait.anyEmployee": "Client's choice",
    "Forfait.duration": "Duration",
    "Forfait.price": "Price",
    "Forfait.priceHint": "Leave empty = resolved by employee",
    "Forfait.pause": "Pause",
    "Forfait.total": "Total",
    "Forfait.save": "Save package",
    "Forfait.missingName": "Name the package before saving.",
    "Forfait.cannotSave": "Cannot save yet: {reason}",
    "Forfait.saved": "Package saved",
    "Forfait.saveFailed": "Could not save the package",
    "Forfait.inactiveBadge": "Inactive",
    "Forfait.brokenBadge": "Needs fixing",
    "Forfait.issue.serviceRemoved": "Removed service",
    "Forfait.issue.serviceOffline": "Call-only service",
    "Forfait.issue.employeeGone": "Deactivated employee",
    "Forfait.issue.employeeOffline": "Employee not bookable online",
    "Forfait.issue.hiddenOnlineSuffix": ", hidden online",
    "Forfait.error.brokenActive": "This package can't be Active: {reasons}. Restore the removed service or reassign the deactivated employee, or set the package Inactive.",
    "Forfait.deleted": "Package deleted",
    "Forfait.deleteFailed": "Could not delete the package",
    "Forfait.deleteConfirm": "Delete this package? Already-booked appointments are not affected.",
    "Forfait.error.minServices": "A package needs at least 2 services",
    "Forfait.error.maxServices": "A package can have at most 5 services",
    "Forfait.error.startsWithService": "A package must start with a service",
    "Forfait.error.endsWithService": "A package must end with a service",
    "Forfait.error.variableDurationNeeded": "Set a duration for the variable-duration service",
    "Forfait.warning.doublePause": "This service already ends with a pause: double pause, is that intended?",
    "Forfait.alreadyIncluded": "Already in your selection",
    "Forfait.tooManyForBooking": "This package has too many services to add to the current appointment.",
    "SalonManagement.openingHours": "Opening Hours",
    "SalonManagement.salonGeneralHours": "Salon General Hours",
    "SalonManagement.individualSchedules": "Individual Employee Schedules",
    "SalonManagement.sameScheduleQuestion": "Do all your employees have the same schedule as the salon?",
    "SalonManagement.saveOpeningHours": "Save Opening Hours",
    "SalonManagement.yes": "Yes",
    "SalonManagement.no": "No",
    "SalonManagement.maxPortfolioImages": "Maximum 6 portfolio images allowed",
    "SalonManagement.selectOnlyImages": "Please select only image files",
    "SalonManagement.aboutMeLimit": "About me must be 200 characters or less",
    "SalonManagement.addOneSegment": "Please add at least one segment",
    "SalonManagement.segmentDurationsMust": "Segment durations",
    "SalonManagement.equalTotalDuration": "must equal total duration",
    "SalonManagement.enterPrice": "Please enter a price",
    "SalonManagement.enterDuration": "Please enter a duration",
    "SalonManagement.setSalonHours": "Please set salon opening hours",
    "SalonManagement.setHoursFor": "Please set hours for",
    "SalonManagement.hoursWithinSalon": "'s hours must be within salon operating hours",
    "SalonManagement.subsection": "Subsection",
    "SalonManagement.manageSubsections": "Manage Subsections",
    "ServiceLevelPricing.button": "Prices by level",
    "ServiceLevelPricing.title": "Prices & durations by level",
    "ServiceLevelPricing.description": "Set the price and duration per level. A per-employee override still takes priority; otherwise the level price applies, then the service default.",
    "ServiceLevelPricing.level": "Level",
    "ServiceLevelPricing.saved": "Level prices saved",
    "ServiceLevelPricing.saveFailed": "Could not save level prices",
    "ServiceLevelPricing.loadFailed": "Could not load level prices",
    "ServiceLevelPricing.switchLevelTitle": "Switch level?",
    "ServiceLevelPricing.switchLevelDescription": "The prices you typed for this level will be lost, and the other level's grid will load.",
    "ServiceLevelPricing.switchLevelConfirm": "Switch level",
    "ServiceLevelPricing.applyToEmployees": "Apply to this level's employees",
    "ServiceLevelPricing.saveFirst": "Save the grid first.",
    "ServiceLevelPricing.applyTitle": "Apply level {level} to employees",
    "ServiceLevelPricing.applyDescription": "These prices will change. Untick the ones to keep.",
    "ServiceLevelPricing.applyNothing": "Every employee at this level already matches the grid.",
    "ServiceLevelPricing.applySelectAll": "Select all",
    "ServiceLevelPricing.applyConfirm": "Apply {count} changes",
    "ServiceLevelPricing.applyConfirmOne": "Apply {count} change",
    "ServiceLevelPricing.applyDone": "{count} prices updated.",
    "ServiceLevelPricing.applyDoneOne": "{count} price updated.",
    "ServiceLevelPricing.applyFailed": "The prices were not applied. Nothing was changed.",
    "ServiceLevelPricing.previewFailed": "The preview could not be loaded.",
    "ServiceLevelPricing.applyNoneSelected": "Tick at least one change.",
    "ServiceLevelPricing.colEmployee": "Employee",
    "ServiceLevelPricing.colService": "Service",
    "ServiceLevelPricing.colPrice": "Price",
    "ServiceLevelPricing.colDuration": "Duration",
    "ServiceLevelPricing.inherited": "inherited",
    "BulkPriceAdjust.button": "Adjust prices",
    "BulkPriceAdjust.title": "Adjust prices",
    "BulkPriceAdjust.description": "Increase the price of several services at once. The increase applies to every configured layer (default, level, employee).",
    "BulkPriceAdjust.step1": "1 · Which services?",
    "BulkPriceAdjust.step2": "2 · By how much?",
    "BulkPriceAdjust.step3": "3 · Preview & exceptions",
    "BulkPriceAdjust.selectAll": "Select all",
    "BulkPriceAdjust.forfaitsGroup": "📦 Packages",
    "BulkPriceAdjust.modePercent": "Percentage (+ %)",
    "BulkPriceAdjust.modeAmount": "Fixed amount (+ $)",
    "BulkPriceAdjust.modeSet": "Set an exact price ($)",
    "BulkPriceAdjust.summary": "Summary",
    "BulkPriceAdjust.summaryServicesOne": "{count} service",
    "BulkPriceAdjust.summaryServices": "{count} services",
    "BulkPriceAdjust.summaryEmployeePricesOne": "{count} employee price",
    "BulkPriceAdjust.summaryEmployeePrices": "{count} employee prices",
    "BulkPriceAdjust.summaryLevelPricesOne": "{count} level price",
    "BulkPriceAdjust.summaryLevelPrices": "{count} level prices",
    "BulkPriceAdjust.summaryForfaitsOne": "{count} package line",
    "BulkPriceAdjust.summaryForfaits": "{count} package lines",
    "BulkPriceAdjust.summaryExceptionsOne": "{count} exception",
    "BulkPriceAdjust.summaryExceptions": "{count} exceptions",
    "BulkPriceAdjust.summarySkippedOne": "{count} skipped",
    "BulkPriceAdjust.summarySkipped": "{count} skipped",
    "BulkPriceAdjust.skipped": "skipped",
    "BulkPriceAdjust.frozen": "frozen",
    "BulkPriceAdjust.noEmployees": "No employee configured",
    "BulkPriceAdjust.apply": "Apply increase",
    "BulkPriceAdjust.missingSelection": "Choose at least one service or package to adjust.",
    "BulkPriceAdjust.missingValue": "Enter the increase amount, zero or more.",
    "BulkPriceAdjust.applied": "Prices adjusted",
    "BulkPriceAdjust.applyFailed": "Increase failed",
    "BulkPriceAdjust.previewFailed": "Preview unavailable",
    "BulkPriceAdjust.freezeToggle": "Freeze or unfreeze this price",
    "SalonManagement.manageSubsectionsDescription": "Create and organize subsections for your services",
    "SalonManagement.subsectionName": "Subsection Name",
    "SalonManagement.enterSubsectionName": "Name a subgroup of services",
    "SalonManagement.existingSubsections": "Existing Subsections",
    "SalonManagement.addSubsection": "Add",
    "SalonManagement.subsectionNameRequired": "Name the subsection.",
    "SalonManagement.subsectionSectionRequired": "Choose the section this subsection belongs to.",
    "SalonManagement.updateSubsection": "Update",
    "SalonManagement.noSubsectionsYet": "No subsections yet",
    "SalonManagement.noSectionsYet": "No sections available. Create sections first.",
    "SalonManagement.confirmDeleteSubsectionTitle": "Delete subsection?",
    "SalonManagement.confirmDeleteSubsection": "Are you sure you want to delete this subsection?",
    "SalonManagement.subsectionDeleted": "Subsection deleted successfully",
    "SalonManagement.subsectionCreated": "Subsection created successfully",
    "SalonManagement.subsectionUpdated": "Subsection updated successfully",
    "SalonManagement.selectSubsection": "Select Subsection",

    // Section Management Dialog
    "SectionDialog.title": "Manage Sections",
    "SectionDialog.description": "Organize your services by creating and managing sections",
    "SectionDialog.noSections": "No sections yet",
    "SectionDialog.createFirst": "Create your first section below",
    "SectionDialog.service": "service",
    "SectionDialog.services": "services",
    "SectionDialog.save": "Save",
    "SectionDialog.cancel": "Cancel",
    "SectionDialog.createNew": "Create New Section",
    "SectionDialog.placeholder": "Name a group of services",
    "SectionDialog.create": "Create",
    "SectionDialog.close": "Close",
    "SectionDialog.deleteConfirm": "Delete section",
    "SectionDialog.servicesUncategorized": "Services will be uncategorized.",
    "SectionDialog.deleteConfirmNamed": "Delete the section \"{name}\"?",
    "SectionDialog.deleteImpactSubsection": "{count} subsection will be deleted with it.",
    "SectionDialog.deleteImpactSubsections": "{count} subsections will be deleted with it.",
    "SectionDialog.deleteImpactService": "{count} service will be left with no section.",
    "SectionDialog.deleteImpactServices": "{count} services will be left with no section.",
    "SectionDialog.deleteImpactNone": "No subsection and no service will be affected.",
    "SectionDialog.deleteImpactUnavailable": "Unable to establish how many subsections and services this would affect.",

    // Service Dialog
    "ServiceDialog.enterSectionName": "Enter a new section name",
    "ServiceDialog.enterServiceName": "Enter service name",
    "ServiceDialog.shortNameLabel": "Short name",
    "ServiceDialog.shortNamePlaceholder": "e.g., CH",
    "ServiceDialog.shortNameHelp": "Optional. Used for quick search.",
    "ServiceDialog.priceLabel": "Price ($)",
    "ServiceDialog.durationLabel": "Duration (min)",
    "ServiceDialog.enterDescription": "Enter service description",
    "ServiceDialog.onlineState.title": "Online display and booking",
    "ServiceDialog.onlineState.bookable": "Bookable online",
    "ServiceDialog.onlineState.displayOnly": "Shown, call only",
    "ServiceDialog.onlineState.hidden": "Hidden",
    "ServiceDialog.onlineState.bookableDesc":
      "Clients see this service on your booking page and can book it themselves.",
    "ServiceDialog.onlineState.displayOnlyDesc":
      "Clients see this service on your booking page, with a \"Call to book\" mention. They cannot book it online.",
    "ServiceDialog.onlineState.hiddenDesc":
      "This service does not appear on your booking page. It stays available at the counter and in your calendar.",
    "ServiceDialog.maxSimultaneous": "Maximum simultaneous bookings",
    "ServiceDialog.maxSimultaneousDesc":
      "Limit how many clients can book this service at the same time across all employees (e.g., for limited equipment or treatment rooms).",
    "ServiceDialog.maxSimultaneousPlaceholder": "Leave empty for unlimited",
    "ServiceDialog.maxSimultaneousHint":
      "Empty or 0 = no limit. Example: Set to 2 if you only have 2 machines for this service.",
    "Services.cost.title": "Cost of goods",
    "Services.cost.subtitle": "For the salon, all employees combined",
    "Services.cost.label": "Cost of products used",
    "Services.cost.unit": "Cost unit",
    "Services.cost.unitFixed": "Dollars",
    "Services.cost.unitPercent": "Percent",
    "Services.cost.hintFixed": "Amount in dollars taken off each sale of this service.",
    "Services.cost.hintPercent": "Percentage of the price actually charged for the sale, not of the catalog price.",
    "Services.cost.note": "Deducted before the commission only for rules set to “After costs”.",
    "Services.cost.afterSave": "The cost can be set once the service is saved.",
    "Services.cost.invalid": "Enter a valid amount, or a percentage between 0 and 100.",
    "Services.cost.loadFailed": "The cost of goods could not be loaded.",
    "Services.cost.retry": "Retry",
    "Services.cost.saveFailed": "The cost of goods could not be saved.",
    "Services.cost.saved": "Saved",
    "Services.cost.error.rule_forbidden": "You do not have access to this cost.",
    "Services.cost.error.service_not_found": "This service no longer exists.",
    "Services.cost.error.service_cost_invalid": "Enter a valid amount, or a percentage between 0 and 100.",
    "ServiceDialog.update": "Update",
    "ServiceDialog.add": "Add",
    "ServiceDialog.addDescription": "Add the details of your new service",
    "ServiceDialog.editDescription": "Update the details of your service",
    "ServiceDialog.employeePricing.title": "Price per employee",
    "ServiceDialog.employeePricing.description": "Set different prices depending on the employee",
    "ServiceDialog.employeePricing.hint": "Base price: ${price}. Leave empty to use the base price.",
    "ServiceDialog.employeePricing.toggle": "Same price for all",
    "ServiceDialog.employeePricing.noEligible": "No eligible employees. Select a service category.",
    "ServiceDialog.employeePricing.noEmployees": "No employees configured. Add employees in the Team section to set values.",
    "ServiceDialog.employeePricing.noEligibleError": "No eligible employees for this service. Add employees or modify specializations.",
    "ServiceDialog.employeePricing.missingPrices": "Please enter a price for all eligible employees.",
    "ServiceDialog.priceRange.title": "Price range (optional)",
    "ServiceDialog.priceRange.description": "Sets a minimum and maximum price for this service on invoices. Discounts cannot bring the price below the minimum. Paid and locked invoices are not affected. Editing an existing invoice will apply the new bounds on save.",
    "ServiceDialog.priceRange.minLabel": "Minimum price",
    "ServiceDialog.priceRange.maxLabel": "Maximum price",
    "ServiceDialog.priceRange.minPlaceholder": "No minimum",
    "ServiceDialog.priceRange.maxPlaceholder": "No maximum",
    "ServiceDialog.priceRange.invalidMin": "The minimum price must be a non-negative number.",
    "ServiceDialog.priceRange.invalidMax": "The maximum price must be a non-negative number.",
    "ServiceDialog.priceRange.minGreaterThanMax": "The minimum price must be less than or equal to the maximum price.",
    "ServiceDialog.priceRange.employeeOutOfRange": "{name} has a price ({price}$) outside the allowed range ({min}$ to {max}$).",
    "ServiceDialog.deposit.title": "Deposit (optional)",
    "ServiceDialog.deposit.description": "By default this service follows the salon deposit policy. Turn this on to give it a rule of its own.",
    "ServiceDialog.deposit.override": "Give this service its own deposit rule",
    "ServiceDialog.deposit.typeLabel": "How it is worked out",
    "ServiceDialog.deposit.typePercentage": "A share of the price",
    "ServiceDialog.deposit.typeFixed": "A fixed amount",
    "ServiceDialog.deposit.valuePercentage": "Share of the price (%)",
    "ServiceDialog.deposit.valueFixed": "Amount ($)",
    "ServiceDialog.deposit.invalidValue": "Enter a deposit greater than zero.",
    "ServiceDialog.deposit.percentageTooHigh": "A share of the price cannot go over 100 %.",
    "ServiceDialog.deposit.floorNote": "Below {floor} no deposit is asked, and none is asked either when the minimum would exceed half the price.",
    "ServiceDialog.deposit.notBookableOnline": "This service can't be booked online, so no deposit can be requested for it.",
    "ServiceDialog.quantityRange.title": "Quantity constraints (optional)",
    "ServiceDialog.quantityRange.description": "Locks the quantity that can be billed for this service on invoices. Use Min/Max to set a range, or Fixed to lock to one exact value. Paid and locked invoices are not affected. Editing an existing invoice will apply the new bounds on save.",
    "ServiceDialog.quantityRange.minLabel": "Minimum quantity",
    "ServiceDialog.quantityRange.maxLabel": "Maximum quantity",
    "ServiceDialog.quantityRange.fixedLabel": "Fixed quantity",
    "ServiceDialog.quantityRange.minPlaceholder": "No minimum",
    "ServiceDialog.quantityRange.maxPlaceholder": "No maximum",
    "ServiceDialog.quantityRange.fixedPlaceholder": "No fixed quantity",
    "ServiceDialog.quantityRange.invalidMin": "Minimum quantity must be a whole number ≥ 1.",
    "ServiceDialog.quantityRange.invalidMax": "Maximum quantity must be a whole number ≥ 1.",
    "ServiceDialog.quantityRange.invalidFixed": "Fixed quantity must be a whole number ≥ 1.",
    "ServiceDialog.quantityRange.invalidRange": "Minimum quantity must be less than or equal to maximum quantity.",
    "ServiceDialog.quantityRange.fixedExclusive": "Fixed quantity cannot be used together with Min/Max. Clear one before saving.",
    "ServiceDialog.quantityRange.disabledByFixed": "Disabled because Fixed quantity is set.",
    "ServiceDialog.quantityRange.disabledByRange": "Disabled because Min or Max quantity is set.",
    "ServiceDialog.employeePricingDuration.title": "Price and duration per employee",
    "ServiceDialog.employeeDuration.title": "Duration per employee",
    "ServiceDialog.employeeDurations.missingDurations": "Please enter a duration for all eligible employees.",
    "ServiceDialog.employee": "Employee",
    "ServiceDialog.price": "Price",
    "ServiceDialog.duration": "Duration",
    "ServiceDialog.priceType.fixed": "Fixed",
    "ServiceDialog.priceType.variable": "Variable",
    "ServiceDialog.priceType.startingFrom": "Starting from",
    "ServiceDialog.durationType.fixed": "Fixed",
    "ServiceDialog.durationType.variable": "Variable",
    "ServiceDialog.durationType.startingFrom": "Starting from",
    "ServiceDialog.priceVariableHint": "The price will be determined individually",
    "ServiceDialog.durationVariableHint": "The duration will be determined individually",
    "ServiceDialog.copyToAll": "Apply to all",
  },
  fr: {

    // ServiceSelector
    "Services.title": "Sélectionnez un service",
    "Services.subtitle": "Choisissez parmi nos services",
    "Services.subtitleMulti": "Sélectionnez un ou plusieurs services",
    "Services.duration": "min",
    "Services.noServices": "Aucun service disponible",
    "Services.callToBook": "Appeler pour réserver",
    "Services.onlineBooking": "Réservation en ligne",
    "Services.hiddenOnline": "Masqué en ligne",
    "Services.selectService": "Sélectionner un service",
    "Services.searchService": "Rechercher un service...",
    "Services.pickerOtherServices": "Autres services",
    "Services.pickerServices": "Services",
    "Services.noServiceFound": "Aucun service trouvé",
    "Services.variableDuration": "Durée variable",
    "Services.startingFromDuration": "Dès {duration} min",
    "Services.variablePrice": "Prix variable",
    "Services.startingFromPrice": "À partir de {price}",
    "Services.seeMore": "voir plus",
    "Services.seeLess": "voir moins",
    "Services.durationLabel": "Durée du service (minutes) *",
    "Services.durationPlaceholder": "Ex: 60",
    "Services.durationRequired": "Veuillez entrer la durée du service",
    "Services.enterDurationFirst": "Saisissez d'abord une durée",
    "Services.variableDurationNote": "Ce service a une durée variable. Veuillez indiquer la durée prévue en minutes.",
    "Services.variableDurationAutoDisable":
      "La réservation en ligne est désactivée automatiquement pour les services à durée variable.",
    "Services.selectedCount": "{count} services sélectionnés",
    "Services.selectedCountSingular": "1 service sélectionné",
    "Services.priceFrom": "À partir de",
    "Services.employeePricing.title": "Prix par employé",
    "Services.employeePricing.description": "Définir des prix différents selon l'employé",
    "Services.employeePricing.hint": "Le prix de base sera utilisé pour les employés sans prix personnalisé",
    "Services.employeePricing.toggle": "Prix identique pour tous",
    "Services.employeePricing.basePrice": "Prix de base",
    "Services.employeePricing.customPrice": "Prix personnalisé",

    // ServicesView
    "Services.headerSubtitle": "Catalogue, forfaits et prix du salon.",
    "Services.tabCatalogue": "Catalogue",
    "Services.tileServices": "Services",
    "Services.tileCategories": "Catégories",
    "Services.tileAvgPrice": "Prix moyen",
    "Services.catalogueTitle": "Catalogue",
    "Services.catalogueDesc": "Services regroupés par section.",
    "Services.loadFailedTitle": "Vos services n'ont pas pu être chargés",
    "Services.loadFailedEmpty": "Ce n'est pas un catalogue vide. La lecture a échoué, donc rien ne peut être affiché pour l'instant. Réessayez, et reconnectez-vous si l'échec persiste.",
    "Services.loadFailedStale": "Le catalogue n'a pas pu être rechargé. Ce qui s'affiche peut ne plus correspondre à ce qui est enregistré.",
    "Services.reloadSucceeded": "Le catalogue est de nouveau chargé et à jour.",
    "Services.reloadFailedAgain": "Le catalogue n'a toujours pas pu être chargé. Ce qui s'affiche peut ne plus correspondre à ce qui est enregistré. Réessayez, et reconnectez-vous si l'échec persiste.",
    "Services.sectionWriteBlockedStale": "La liste des services affichée n'a pas pu être rechargée, elle peut ne plus correspondre à ce qui est enregistré. Rechargez le catalogue avant de renommer ou de supprimer une section.",
    "Services.uncategorized": "Sans catégorie",
    "Services.catalogueHint": "catalogue {details}",
    "Services.catalogueSearchPlaceholder": "Rechercher un service",
    "Services.catalogueColService": "Service",
    "Services.catalogueColDuration": "Durée",
    "Services.catalogueColPrice": "Prix",
    "Services.catalogueColOnline": "En ligne",
    "Services.catalogueColShortName": "Nom court",
    "Services.catalogueColDescription": "Description",
    "Services.catalogueFilterOnline": "Filtrer par état en ligne",
    "Services.catalogueNoMatch": "Aucun service ne correspond à votre recherche.",
    "Services.catalogueClearSearch": "Effacer la recherche",
    "Services.catalogueShown": "{shown} services affichés sur {total}",
    "Services.catalogueShownOne": "{shown} service affiché sur {total}",
    "Services.catalogueExpand": "Déplier {group}",
    "Services.catalogueCollapse": "Replier {group}",
    // Invites des champs de prix et de duree par employe. Elles doivent se LIRE comme
    // des exemples : « 0.00 » et « 30 » passaient pour des valeurs deja saisies
    // (audit 2026-08-26, probleme 85).
    "Services.priceExample": "ex. 45",
    "Services.durationExample": "ex. 30",
    "Services.forfaitsDesc": "Regroupez plusieurs services en un forfait.",
    "SalonManagement.add": "Ajouter",
    "Forfait.empty": "Aucun forfait pour le moment.",

    // Salon Info - Tax numbers
    "SalonManagement.tpsNumber": "Numéro de TPS",
    "SalonManagement.tvqNumber": "Numéro de TVQ",

    // SalonManagement
    "SalonManagement.salonInfo": "Informations du salon",
    "SalonManagement.salonName": "Nom du salon",
    "SalonManagement.required": "Requis",
    "SalonManagement.address": "Adresse",
    "SalonManagement.phone": "Téléphone",
    "SalonManagement.email": "Courriel",
    "SalonManagement.invalidEmail": "Veuillez entrer une adresse courriel valide",
    "SalonManagement.website": "Site web",
    "SalonManagement.enterWebsite": "Entrez l'adresse de votre site web",
    "SalonManagement.invalidWebsite": "Veuillez entrer une adresse de site web valide",
    "SalonManagement.googleReviewsUrl": "Lien d'avis Google",
    "SalonManagement.enterGoogleReviewsUrl": "https://g.page/r/.../review",
    "SalonManagement.invalidGoogleReviewsUrl": "Veuillez entrer un lien d'avis Google valide",
    "SalonManagement.reviewRequestsEnabled": "Les clients reçoivent une demande d'avis après leur rendez-vous.",
    "SalonManagement.reviewRequestsDisabled": "Aucune demande d'avis n'est envoyée.",
    "SalonManagement.descriptionDiscounts": "Description / Promotions spéciales",
    "SalonManagement.saveSalonInfo": "Enregistrer les infos du salon",
    "SalonManagement.saveChanges": "Enregistrer les modifications",
    "SalonManagement.hairdressers": "Employés",
    "SalonManagement.addHairdresser": "Ajouter un(e) employé(e)",
    "SalonManagement.noHairdressersYet":
      "Aucun(e) employé(e) pour le moment. Ajoutez votre premier(ère) employé(e) pour commencer!",
    "SalonManagement.edit": "Modifier",
    "SalonManagement.delete": "Supprimer",
    "SalonManagement.addNewHairdresser": "Ajouter un(e) nouveau(elle) employé(e)",
    "SalonManagement.editHairdresser": "Modifier l'employé(e)",
    "SalonManagement.hairdresserName": "Nom de la personne",
    "SalonManagement.level": "Niveau",
    "SalonManagement.selectLevel": "Sélectionner le niveau",
    "SalonManagement.noLevel": "Aucun",
    "SalonManagement.newTalent": "Nouveau-talent",
    "SalonManagement.beginner": "Débutant",
    "SalonManagement.intermediate": "Intermédiaire",
    "SalonManagement.advanced": "Avancé",
    "SalonManagement.expert": "Expert",
    "SalonManagement.profilePicture": "Photo de profil",
    "SalonManagement.uploadImage": "Télécharger une image",
    "SalonManagement.cancel": "Annuler",
    "SalonManagement.save": "Enregistrer",
    "SalonManagement.calendarColor": "Couleur du calendrier",
    "SalonManagement.resetColor": "Réinitialiser la couleur",
    "SalonManagement.colorPreview": "Aperçu",
    "SalonManagement.specializations": "Spécialisations",
    "SalonManagement.specializationsDescription":
      "Sélectionnez les sections, sous-sections et services que cet(te) employé(e) peut réaliser. Si aucune n'est sélectionnée, il/elle ne peut gérer aucun service.",
    "SalonManagement.noSections": "Aucune section disponible. Créez d'abord des sections.",
    "SalonManagement.employeeSpecializations": "Spécialisations des employés",
    "SalonManagement.selectEmployee": "Sélectionner un employé",
    "SalonManagement.specializationHelp": "Sélectionnez les sections et sous-sections que cet employé peut effectuer. Utilisez l'icône ✎ pour affiner par service.",
    "SalonManagement.specializationSaved": "Spécialisations enregistrées",
    "SalonManagement.servicesCount": "{count}/{total} services",
    "SalonManagement.servicesCountCompact": "{count}/{total}",
    "SalonManagement.servicesForSubsection": "Services : {name}",
    "SalonManagement.noSubsectionLabel": "Sans sous-section",
    "SalonManagement.servicesSelected": "{count} sur {total} services sélectionnés",
    "SalonManagement.selectAllServices": "Tout sélectionner",
    "SalonManagement.deselectAllServices": "Tout désélectionner",
    "SalonManagement.noServicesInSubsection": "Aucun service dans cette sous-section.",
    "SalonManagement.serviceColor": "Couleur du service",
    "SalonManagement.serviceColorHint": "Optionnel. Utilisé quand le mode \"Par service\" est activé.",
    "ServiceSegments.requireDurations": "Renseignez d'abord une durée pour chaque employé éligible avant de diviser en segments.",

    "SalonManagement.services": "Services",
    "SalonManagement.addService": "Ajouter un service",
    "SalonManagement.section": "Section",
    "SalonManagement.sections": "Sections",
    "SalonManagement.subsections": "Sous-sections",
    "SalonManagement.reorder": "Réorganiser",
    "Organize.button": "Organiser",
    "Organize.online": "En ligne (clients)",
    "Organize.internal": "À l'interne (personnel)",
    "Organize.emptyNoServices": "Aucun service à organiser pour le moment. Ajoutez vos services dans l'onglet Catalogue et ils apparaîtront ici, sous leur section.",
    "Organize.emptyServicesUnknown": "Vos services n'ont pas pu être lus, il n'y a donc rien à organiser pour l'instant. Ce n'est pas un catalogue vide.",
    "Organize.emptyNoSection": "Vos services ne sont rattachés à aucune de vos sections, il n'y a donc aucun ordre à régler ici. Donnez une section à vos services dans l'onglet Catalogue et ils apparaîtront ici.",
    "Organize.reorderFailed": "Le nouvel ordre n'a pas pu être entièrement enregistré. La liste est rechargée pour afficher l'ordre réellement enregistré.",
    "SalonManagement.reorderDone": "Terminé",
    "SalonManagement.noServices": "Aucun service pour le moment. Ajoutez votre premier service pour commencer!",
    "SalonManagement.duration": "Durée",
    "SalonManagement.min": "min",
    "SalonManagement.variable": "Variable",
    "SalonManagement.priceStartingFrom": "À partir de {price}",
    "SalonManagement.durationStartingFrom": "Dès {duration} min",
    "SalonManagement.addNewService": "Ajouter un nouveau service",
    "SalonManagement.editService": "Modifier le service",
    "SalonManagement.selectSection": "Sélectionner une section",
    "SalonManagement.uncategorized": "Non catégorisé",
    "SalonManagement.createNewSection": "Créer une nouvelle section",
    "SalonManagement.serviceName": "Nom du service",
    "SalonManagement.price": "Prix",
    "SalonManagement.description": "Description",
    "SalonManagement.salonInfoUpdated": "Informations du salon mises à jour avec succès",
    "SalonManagement.failedToUpdateSalon": "Échec de la mise à jour des informations du salon",
    "SalonManagement.success": "Succès",
    "SalonManagement.hairdresserUpdated": "Employé(e) mis(e) à jour",
    "SalonManagement.hairdresserAdded": "Employé(e) ajouté(e)",
    "SalonManagement.hairdresserDeleted": "Employé(e) supprimé(e) avec succès",
    "SalonManagement.serviceUpdated": "Service mis à jour",
    "SalonManagement.serviceAdded": "Service ajouté",
    "SalonManagement.serviceDeleted": "Service supprimé. Les rendez-vous associés ont été mis à jour.",
    "SalonManagement.sectionDeletedNone": "Section supprimée",
    "SalonManagement.sectionDeletedService": "Section supprimée, 1 service est maintenant sans section",
    "SalonManagement.sectionDeletedServices": "Section supprimée, {count} services sont maintenant sans section",
    "SalonManagement.sectionCreated": "Section créée avec succès",
    "SalonManagement.sectionRenamed": "Section renommée avec succès",
    "SalonManagement.sectionRenamePartial": "La section a été renommée, mais ses services n'ont pas tous suivi. La liste est rechargée pour montrer l'état réel.",
    "SalonManagement.sectionDeletePartialService": "La section n'a pas été supprimée, mais {count} service a déjà perdu son rattachement. La liste est rechargée pour montrer l'état réel.",
    "SalonManagement.sectionDeletePartialServices": "La section n'a pas été supprimée, mais {count} services ont déjà perdu leur rattachement. La liste est rechargée pour montrer l'état réel.",
    "SalonManagement.openingHoursUpdated": "Heures d'ouverture mises à jour",
    "SalonManagement.salonInfoUpdatedShort": "Informations du salon mises à jour",
    "SalonManagement.invalidImageFile": "Veuillez sélectionner un fichier image valide",
    "SalonManagement.fileTooLarge": "La taille du fichier doit être inférieure à 5 Mo",
    "SalonManagement.hairdresserNameRequired": "Le nom de la personne est requis",
    "SalonManagement.noSalonFound": "Aucun salon trouvé",
    "SalonManagement.fillRequiredFields": "Veuillez remplir tous les champs requis",
    "SalonManagement.enterSectionName": "Veuillez entrer un nom de section",
    "SalonManagement.enterSalonName": "Entrez le nom du salon",
    "SalonManagement.enterAddress": "Entrez l'adresse",
    "SalonManagement.enterPhone": "Entrez le numéro de téléphone",
    "SalonManagement.enterEmail": "Entrez l'adresse courriel",
    "SalonManagement.enterDescription": "Entrez une description",
    "SalonManagement.salonNameRequired": "Le nom du salon est requis",
    "SalonManagement.serviceDeletedSimple": "Service supprimé avec succès",
    "SalonManagement.confirmDeletion": "Confirmer la suppression",
    "SalonManagement.deleteServiceConfirm": "Êtes-vous sûr de vouloir supprimer ce service ?",
    "SalonManagement.deleteServiceWarning": "Attention :",
    "SalonManagement.deleteServiceWarningText":
      "Si des rendez-vous utilisent ce service, ils seront mis à jour sans service assigné.",
    "SalonManagement.deleteServiceConfirmNamed": "Êtes-vous sûr de vouloir supprimer le service « {name} » ?",
    "SalonManagement.deleteServiceImpactAppointment": "{count} rendez-vous perdra son service.",
    "SalonManagement.deleteServiceImpactAppointments": "{count} rendez-vous perdront leur service.",
    "SalonManagement.deleteServiceImpactNone": "Aucun rendez-vous n'utilise ce service.",
    "SalonManagement.deleteServiceImpactUnavailable": "Impossible d'établir combien de rendez-vous seraient touchés.",
    "SalonManagement.deleteCountInProgress":
      "Un décompte de suppression est déjà en cours. Attendez qu'il se termine avant d'en ouvrir un autre.",
    "SalonManagement.deleteHairdresserConfirm":
      "Êtes-vous sûr de vouloir supprimer cet(te) employé(e) ? Cette action ne peut pas être annulée.",
    "SalonManagement.deleteButton": "Supprimer",
    "SalonManagement.client": "Client",
    "SalonManagement.selectClient": "Sélectionner un client...",
    "SalonManagement.searchClient": "Rechercher un client par nom, courriel ou téléphone...",
    "SalonManagement.noClientFound": "Aucun client trouvé.",
    "ServiceSegments.title": "Diviser le service en segments travail/pause",
    "ServiceSegments.description": "Définir les périodes de travail et de pause pour ce service",
    "ServiceSegments.enabled": "Activé",
    "ServiceSegments.disabled": "Désactivé",
    "ServiceSegments.work": "Travail",
    "ServiceSegments.pause": "Pause",
    "ServiceSegments.min": "min",
    "ServiceSegments.addSegment": "Ajouter un segment",
    "ServiceSegments.total": "Total :",
    "ServiceSegments.mustEqual": "Doit égaler",
    "ServiceSegments.defaultLabel": "Par défaut (tous les employés)",
    "ServiceSegments.perEmployee": "Par employé",
    "ServiceSegments.customize": "Personnaliser",
    "ServiceSegments.customized": "Personnalisé",
    "ServiceSegments.reset": "Réinitialiser",
    "ServiceSegments.mustEqualEmployee": "doit = durée pour {name}",
    "ServiceSegments.defaultBadge": "Par défaut",
    "ServiceSegments.firstMustBeWork": "Le premier segment doit être du travail",
    "ServiceSegments.lastMustBeWork": "Le dernier segment doit être du travail",
    "Forfait.title": "Forfaits",
    "Forfait.addForfait": "Forfait",
    "Forfait.new": "Nouveau forfait",
    "Forfait.edit": "Modifier le forfait",
    "Forfait.addDescription": "Ajoutez les détails de votre nouveau forfait",
    "Forfait.editDescription": "Modifiez les détails de votre forfait",
    "Forfait.name": "Nom du forfait",
    "Forfait.nameLabel": "Nom du forfait",
    "Forfait.descriptionLabel": "Description",
    "Forfait.description": "Description (optionnel)",
    "Forfait.active": "Actif",
    "Forfait.activeHint": "Visible sur la page de réservation",
    "Forfait.addService": "Ajouter un service",
    "Forfait.addPause": "Ajouter une pause",
    "Forfait.employee": "Employé",
    "Forfait.anyEmployee": "Au choix",
    "Forfait.duration": "Durée",
    "Forfait.price": "Prix",
    "Forfait.priceHint": "Vide = résolu selon l'employé",
    "Forfait.pause": "Temps de pause",
    "Forfait.total": "Total",
    "Forfait.save": "Enregistrer le forfait",
    "Forfait.missingName": "Donnez un nom au forfait avant d'enregistrer.",
    "Forfait.cannotSave": "Enregistrement impossible : {reason}",
    "Forfait.saved": "Forfait enregistré",
    "Forfait.saveFailed": "Impossible d'enregistrer le forfait",
    "Forfait.inactiveBadge": "Inactif",
    "Forfait.brokenBadge": "À corriger",
    "Forfait.issue.serviceRemoved": "Service supprimé",
    "Forfait.issue.serviceOffline": "Service sur appel",
    "Forfait.issue.employeeGone": "Employé désactivé",
    "Forfait.issue.employeeOffline": "Employé sans réservation en ligne",
    "Forfait.issue.hiddenOnlineSuffix": ", masqué en ligne",
    "Forfait.error.brokenActive": "Ce forfait ne peut pas être Actif : {reasons}. Rétablissez le service supprimé ou réassignez l'employé désactivé, ou mettez le forfait Inactif.",
    "Forfait.deleted": "Forfait supprimé",
    "Forfait.deleteFailed": "Échec de la suppression du forfait",
    "Forfait.deleteConfirm": "Supprimer ce forfait ? Les rendez-vous déjà réservés ne sont pas affectés.",
    "Forfait.error.minServices": "Un forfait doit contenir au moins 2 services",
    "Forfait.error.maxServices": "Un forfait peut contenir au plus 5 services",
    "Forfait.error.startsWithService": "Un forfait doit commencer par un service",
    "Forfait.error.endsWithService": "Un forfait doit finir par un service",
    "Forfait.error.variableDurationNeeded": "Indiquez une durée pour le service à durée variable",
    "Forfait.warning.doublePause": "Ce service finit déjà par une pause : double temps de pause, c'est voulu ?",
    "Forfait.alreadyIncluded": "Déjà dans votre sélection",
    "Forfait.tooManyForBooking": "Ce forfait contient trop de services pour être ajouté au rendez-vous en cours.",
    "SalonManagement.openingHours": "Heures d'ouverture",
    "SalonManagement.salonGeneralHours": "Heures d'ouverture du salon",
    "SalonManagement.individualSchedules": "Horaires individuels des employé(e)s",
    "SalonManagement.sameScheduleQuestion": "Est-ce que tous vos employé(e)s ont les mêmes horaires que le salon ?",
    "SalonManagement.saveOpeningHours": "Enregistrer les heures d'ouverture",
    "SalonManagement.yes": "Oui",
    "SalonManagement.no": "Non",
    "SalonManagement.maxPortfolioImages": "Maximum 6 images de portfolio autorisées",
    "SalonManagement.selectOnlyImages": "Veuillez sélectionner uniquement des fichiers image",
    "SalonManagement.aboutMeLimit": "À propos de moi doit contenir 200 caractères ou moins",
    "SalonManagement.addOneSegment": "Veuillez ajouter au moins un segment",
    "SalonManagement.segmentDurationsMust": "Les durées des segments",
    "SalonManagement.equalTotalDuration": "doivent égaler la durée totale",
    "SalonManagement.enterPrice": "Veuillez entrer un prix",
    "SalonManagement.enterDuration": "Veuillez entrer une durée",
    "SalonManagement.setSalonHours": "Veuillez définir les heures d'ouverture du salon",
    "SalonManagement.setHoursFor": "Veuillez définir les heures pour",
    "SalonManagement.hoursWithinSalon": "doit être dans les heures d'ouverture du salon",
    "SalonManagement.subsection": "Sous-section",
    "SalonManagement.manageSubsections": "Gérer les sous-sections",
    "ServiceLevelPricing.button": "Prix par niveau",
    "ServiceLevelPricing.title": "Prix et durées par niveau",
    "ServiceLevelPricing.description": "Configurez le prix et la durée par niveau. Un prix personnalisé par employé reste prioritaire ; sinon le prix du niveau s'applique, puis le défaut du service.",
    "ServiceLevelPricing.level": "Niveau",
    "ServiceLevelPricing.saved": "Prix par niveau enregistrés",
    "ServiceLevelPricing.saveFailed": "Enregistrement des prix par niveau échoué",
    "ServiceLevelPricing.loadFailed": "Chargement des prix par niveau échoué",
    "ServiceLevelPricing.switchLevelTitle": "Changer de niveau ?",
    "ServiceLevelPricing.switchLevelDescription": "Les prix saisis pour ce niveau seront perdus, et la grille de l'autre niveau sera chargée.",
    "ServiceLevelPricing.switchLevelConfirm": "Changer de niveau",
    "ServiceLevelPricing.applyToEmployees": "Appliquer aux employés de ce niveau",
    "ServiceLevelPricing.saveFirst": "Enregistrez d'abord la grille.",
    "ServiceLevelPricing.applyTitle": "Appliquer le niveau {level} aux employés",
    "ServiceLevelPricing.applyDescription": "Voici les prix qui changeront. Décochez ceux à conserver.",
    "ServiceLevelPricing.applyNothing": "Tous les employés de ce niveau sont déjà alignés sur la grille.",
    "ServiceLevelPricing.applySelectAll": "Tout cocher",
    "ServiceLevelPricing.applyConfirm": "Appliquer {count} changements",
    "ServiceLevelPricing.applyConfirmOne": "Appliquer {count} changement",
    "ServiceLevelPricing.applyDone": "{count} prix mis à jour.",
    "ServiceLevelPricing.applyDoneOne": "{count} prix mis à jour.",
    "ServiceLevelPricing.applyFailed": "Les prix n'ont pas été appliqués. Rien n'a été modifié.",
    "ServiceLevelPricing.previewFailed": "L'aperçu n'a pas pu être chargé.",
    "ServiceLevelPricing.applyNoneSelected": "Cochez au moins un changement.",
    "ServiceLevelPricing.colEmployee": "Employé",
    "ServiceLevelPricing.colService": "Service",
    "ServiceLevelPricing.colPrice": "Prix",
    "ServiceLevelPricing.colDuration": "Durée",
    "ServiceLevelPricing.inherited": "hérité",
    "BulkPriceAdjust.button": "Ajuster les prix",
    "BulkPriceAdjust.title": "Ajuster les prix",
    "BulkPriceAdjust.description": "Augmentez les prix de plusieurs services d'un coup. L'augmentation s'applique à toutes les couches configurées (défaut, niveau, employé).",
    "BulkPriceAdjust.step1": "1 · Quels services ?",
    "BulkPriceAdjust.step2": "2 · De combien ?",
    "BulkPriceAdjust.step3": "3 · Aperçu & exceptions",
    "BulkPriceAdjust.selectAll": "Tout sélectionner",
    "BulkPriceAdjust.forfaitsGroup": "📦 Forfaits",
    "BulkPriceAdjust.modePercent": "Pourcentage (+ %)",
    "BulkPriceAdjust.modeAmount": "Montant fixe (+ $)",
    "BulkPriceAdjust.modeSet": "Définir un prix précis ($)",
    "BulkPriceAdjust.summary": "Résumé",
    "BulkPriceAdjust.summaryServicesOne": "{count} service",
    "BulkPriceAdjust.summaryServices": "{count} services",
    "BulkPriceAdjust.summaryEmployeePricesOne": "{count} prix employé",
    "BulkPriceAdjust.summaryEmployeePrices": "{count} prix employés",
    "BulkPriceAdjust.summaryLevelPricesOne": "{count} prix niveau",
    "BulkPriceAdjust.summaryLevelPrices": "{count} prix niveaux",
    "BulkPriceAdjust.summaryForfaitsOne": "{count} ligne forfait",
    "BulkPriceAdjust.summaryForfaits": "{count} lignes forfait",
    "BulkPriceAdjust.summaryExceptionsOne": "{count} exception",
    "BulkPriceAdjust.summaryExceptions": "{count} exceptions",
    "BulkPriceAdjust.summarySkippedOne": "{count} ignoré",
    "BulkPriceAdjust.summarySkipped": "{count} ignorés",
    "BulkPriceAdjust.skipped": "ignoré",
    "BulkPriceAdjust.frozen": "gelé",
    "BulkPriceAdjust.noEmployees": "Aucun employé configuré",
    "BulkPriceAdjust.apply": "Appliquer la hausse",
    "BulkPriceAdjust.missingSelection": "Choisissez au moins un service ou un forfait à ajuster.",
    "BulkPriceAdjust.missingValue": "Saisissez le montant de la hausse, zéro ou plus.",
    "BulkPriceAdjust.applied": "Prix ajustés",
    "BulkPriceAdjust.applyFailed": "Échec de la hausse",
    "BulkPriceAdjust.previewFailed": "Aperçu indisponible",
    "BulkPriceAdjust.freezeToggle": "Geler ou dégeler ce prix",
    "SalonManagement.manageSubsectionsDescription": "Créez et organisez les sous-sections pour vos services",
    "SalonManagement.subsectionName": "Nom de la sous-section",
    "SalonManagement.enterSubsectionName": "Nommez un sous-groupe de prestations",
    "SalonManagement.existingSubsections": "Sous-sections existantes",
    "SalonManagement.addSubsection": "Ajouter",
    "SalonManagement.subsectionNameRequired": "Donnez un nom à la sous-section.",
    "SalonManagement.subsectionSectionRequired": "Choisissez la section à laquelle rattacher la sous-section.",
    "SalonManagement.updateSubsection": "Mettre à jour",
    "SalonManagement.noSubsectionsYet": "Aucune sous-section pour le moment",
    "SalonManagement.noSectionsYet": "Aucune section disponible. Créez d'abord des sections.",
    "SalonManagement.confirmDeleteSubsectionTitle": "Supprimer la sous-section ?",
    "SalonManagement.confirmDeleteSubsection": "Êtes-vous sûr de vouloir supprimer cette sous-section ?",
    "SalonManagement.subsectionDeleted": "Sous-section supprimée avec succès",
    "SalonManagement.subsectionCreated": "Sous-section créée avec succès",
    "SalonManagement.subsectionUpdated": "Sous-section mise à jour avec succès",
    "SalonManagement.selectSubsection": "Sélectionner une sous-section",

    // Section Management Dialog
    "SectionDialog.title": "Gérer les sections",
    "SectionDialog.description": "Organisez vos services en créant et gérant des sections",
    "SectionDialog.noSections": "Aucune section pour le moment",
    "SectionDialog.createFirst": "Créez votre première section ci-dessous",
    "SectionDialog.service": "service",
    "SectionDialog.services": "services",
    "SectionDialog.save": "Enregistrer",
    "SectionDialog.cancel": "Annuler",
    "SectionDialog.createNew": "Créer une nouvelle section",
    "SectionDialog.placeholder": "Nommez une famille de prestations",
    "SectionDialog.create": "Créer",
    "SectionDialog.close": "Fermer",
    "SectionDialog.deleteConfirm": "Supprimer la section",
    "SectionDialog.servicesUncategorized": "Les services seront non catégorisés.",
    "SectionDialog.deleteConfirmNamed": "Supprimer la section « {name} » ?",
    "SectionDialog.deleteImpactSubsection": "{count} sous-section sera supprimée avec elle.",
    "SectionDialog.deleteImpactSubsections": "{count} sous-sections seront supprimées avec elle.",
    "SectionDialog.deleteImpactService": "{count} service se retrouvera sans section.",
    "SectionDialog.deleteImpactServices": "{count} services se retrouveront sans section.",
    "SectionDialog.deleteImpactNone": "Aucune sous-section ni aucun service ne sera touché.",
    "SectionDialog.deleteImpactUnavailable": "Impossible d'établir combien de sous-sections et de services seraient touchés.",

    // Service Dialog
    "ServiceDialog.enterSectionName": "Entrez un nouveau nom de section",
    "ServiceDialog.enterServiceName": "Entrez le nom du service",
    "ServiceDialog.shortNameLabel": "Nom raccourci",
    "ServiceDialog.shortNamePlaceholder": "Ex: CH",
    "ServiceDialog.shortNameHelp": "Optionnel. Utilisé pour la recherche rapide.",
    "ServiceDialog.priceLabel": "Prix ($)",
    "ServiceDialog.durationLabel": "Durée (min)",
    "ServiceDialog.enterDescription": "Entrez la description du service",
    "ServiceDialog.onlineState.title": "Affichage et réservation en ligne",
    "ServiceDialog.onlineState.bookable": "Réservable en ligne",
    "ServiceDialog.onlineState.displayOnly": "Affiché, sur appel",
    "ServiceDialog.onlineState.hidden": "Masqué",
    "ServiceDialog.onlineState.bookableDesc":
      "Les clients voient cette prestation sur votre page de réservation et peuvent la réserver eux-mêmes.",
    "ServiceDialog.onlineState.displayOnlyDesc":
      "Les clients voient cette prestation sur votre page de réservation, avec la mention « Appeler pour réserver ». Ils ne peuvent pas la réserver en ligne.",
    "ServiceDialog.onlineState.hiddenDesc":
      "Cette prestation n'apparaît pas sur votre page de réservation. Elle reste disponible au comptoir et dans votre calendrier.",
    "ServiceDialog.maxSimultaneous": "Réservations simultanées maximum",
    "ServiceDialog.maxSimultaneousDesc":
      "Limitez le nombre de clients pouvant réserver ce service en même temps, tous employés confondus (ex: équipement ou salles de traitement limités).",
    "ServiceDialog.maxSimultaneousPlaceholder": "Laisser vide pour illimité",
    "ServiceDialog.maxSimultaneousHint":
      "Vide ou 0 = pas de limite. Exemple: Mettre 2 si vous n'avez que 2 machines pour ce service.",
    "Services.cost.title": "Coût de revient",
    "Services.cost.subtitle": "Pour le salon, tous employés confondus",
    "Services.cost.label": "Coût des produits utilisés",
    "Services.cost.unit": "Unité du coût",
    "Services.cost.unitFixed": "Dollars",
    "Services.cost.unitPercent": "Pourcentage",
    "Services.cost.hintFixed": "Montant en dollars retranché de chaque vente de ce service.",
    "Services.cost.hintPercent": "Pourcentage du prix réellement facturé pour la vente, et non du prix du catalogue.",
    "Services.cost.note": "Déduit avant la commission seulement pour les règles « Après coûts ».",
    "Services.cost.afterSave": "Le coût se règle une fois le service enregistré.",
    "Services.cost.invalid": "Entrez un montant valide, ou un pourcentage entre 0 et 100.",
    "Services.cost.loadFailed": "Le coût de revient n'a pas pu être chargé.",
    "Services.cost.retry": "Réessayer",
    "Services.cost.saveFailed": "Le coût de revient n'a pas pu être enregistré.",
    "Services.cost.saved": "Enregistré",
    "Services.cost.error.rule_forbidden": "Vous n'avez pas accès à ce coût.",
    "Services.cost.error.service_not_found": "Ce service n'existe plus.",
    "Services.cost.error.service_cost_invalid": "Entrez un montant valide, ou un pourcentage entre 0 et 100.",
    "ServiceDialog.update": "Mettre à jour",
    "ServiceDialog.add": "Ajouter",
    "ServiceDialog.addDescription": "Ajoutez les détails de votre nouveau service",
    "ServiceDialog.editDescription": "Modifiez les détails de votre service",
    "ServiceDialog.employeePricing.title": "Prix par employé",
    "ServiceDialog.employeePricing.description": "Définir des prix différents selon l'employé",
    "ServiceDialog.employeePricing.hint": "Prix de base: ${price}. Laissez vide pour utiliser le prix de base.",
    "ServiceDialog.employeePricing.toggle": "Prix identique pour tous",
    "ServiceDialog.employeePricing.noEligible": "Aucun employé éligible. Sélectionnez une catégorie de service.",
    "ServiceDialog.employeePricing.noEmployees": "Aucun employé configuré. Ajoutez des employés dans la section Équipe pour définir les valeurs.",
    "ServiceDialog.employeePricing.noEligibleError": "Aucun employé éligible pour ce service. Ajoutez des employés ou modifiez les spécialisations.",
    "ServiceDialog.employeePricing.missingPrices": "Veuillez entrer un prix pour tous les employés éligibles.",
    "ServiceDialog.priceRange.title": "Plage de prix (optionnel)",
    "ServiceDialog.priceRange.description": "Définit un prix minimum et un prix maximum pour ce service sur les factures. Les rabais ne peuvent pas faire descendre le prix sous le minimum. Les factures payées et verrouillées ne sont pas affectées. Modifier une facture déjà créée appliquera les nouvelles bornes au moment de l'enregistrement.",
    "ServiceDialog.priceRange.minLabel": "Prix minimum",
    "ServiceDialog.priceRange.maxLabel": "Prix maximum",
    "ServiceDialog.priceRange.minPlaceholder": "Aucun minimum",
    "ServiceDialog.priceRange.maxPlaceholder": "Aucun maximum",
    "ServiceDialog.priceRange.invalidMin": "Le prix minimum doit être un nombre positif ou nul.",
    "ServiceDialog.priceRange.invalidMax": "Le prix maximum doit être un nombre positif ou nul.",
    "ServiceDialog.priceRange.minGreaterThanMax": "Le prix minimum doit être inférieur ou égal au prix maximum.",
    "ServiceDialog.priceRange.employeeOutOfRange": "{name} a un prix ({price}$) en dehors de la plage autorisée ({min}$ à {max}$).",
    "ServiceDialog.deposit.title": "Acompte (optionnel)",
    "ServiceDialog.deposit.description": "Par défaut, cette prestation suit la politique d'acompte du salon. Activez cette option pour lui donner sa propre règle.",
    "ServiceDialog.deposit.override": "Donner à cette prestation sa propre règle d'acompte",
    "ServiceDialog.deposit.typeLabel": "Comment il se calcule",
    "ServiceDialog.deposit.typePercentage": "Une part du prix",
    "ServiceDialog.deposit.typeFixed": "Un montant fixe",
    "ServiceDialog.deposit.valuePercentage": "Part du prix (%)",
    "ServiceDialog.deposit.valueFixed": "Montant ($)",
    "ServiceDialog.deposit.invalidValue": "Saisissez un acompte supérieur à zéro.",
    "ServiceDialog.deposit.percentageTooHigh": "Une part du prix ne peut pas dépasser 100 %.",
    "ServiceDialog.deposit.floorNote": "Sous {floor}, aucun acompte n'est demandé, et aucun ne l'est non plus quand le minimum dépasserait la moitié du prix.",
    "ServiceDialog.deposit.notBookableOnline": "Cette prestation n'est pas réservable en ligne, aucun acompte ne peut donc lui être demandé.",
    "ServiceDialog.quantityRange.title": "Contraintes de quantité (optionnel)",
    "ServiceDialog.quantityRange.description": "Verrouille la quantité facturable pour ce service. Utilisez Min/Max pour définir une plage, ou Fixe pour imposer une valeur exacte. Les factures payées et verrouillées ne sont pas affectées. Modifier une facture déjà créée appliquera les nouvelles bornes au moment de l'enregistrement.",
    "ServiceDialog.quantityRange.minLabel": "Quantité minimum",
    "ServiceDialog.quantityRange.maxLabel": "Quantité maximum",
    "ServiceDialog.quantityRange.fixedLabel": "Quantité fixe",
    "ServiceDialog.quantityRange.minPlaceholder": "Aucun minimum",
    "ServiceDialog.quantityRange.maxPlaceholder": "Aucun maximum",
    "ServiceDialog.quantityRange.fixedPlaceholder": "Aucune quantité fixe",
    "ServiceDialog.quantityRange.invalidMin": "La quantité minimum doit être un nombre entier ≥ 1.",
    "ServiceDialog.quantityRange.invalidMax": "La quantité maximum doit être un nombre entier ≥ 1.",
    "ServiceDialog.quantityRange.invalidFixed": "La quantité fixe doit être un nombre entier ≥ 1.",
    "ServiceDialog.quantityRange.invalidRange": "La quantité minimum doit être inférieure ou égale à la quantité maximum.",
    "ServiceDialog.quantityRange.fixedExclusive": "La quantité fixe ne peut pas être combinée avec Min/Max. Videz l'un des deux avant d'enregistrer.",
    "ServiceDialog.quantityRange.disabledByFixed": "Désactivé car une quantité fixe est définie.",
    "ServiceDialog.quantityRange.disabledByRange": "Désactivé car une quantité min ou max est définie.",
    "ServiceDialog.employeePricingDuration.title": "Prix et durée par employé",
    "ServiceDialog.employeeDuration.title": "Durée par employé",
    "ServiceDialog.employeeDurations.missingDurations": "Veuillez entrer une durée pour tous les employés éligibles.",
    "ServiceDialog.employee": "Employé",
    "ServiceDialog.price": "Prix",
    "ServiceDialog.duration": "Durée",
    "ServiceDialog.priceType.fixed": "Fixe",
    "ServiceDialog.priceType.variable": "Variable",
    "ServiceDialog.priceType.startingFrom": "À partir de",
    "ServiceDialog.durationType.fixed": "Fixe",
    "ServiceDialog.durationType.variable": "Variable",
    "ServiceDialog.durationType.startingFrom": "À partir de",
    "ServiceDialog.priceVariableHint": "Le prix sera déterminé individuellement",
    "ServiceDialog.durationVariableHint": "La durée sera déterminée individuellement",
    "ServiceDialog.copyToAll": "Appliquer à tous",
  },
};
